<template>
  <!--콘텐츠 영역-->

  <div id="sub_contents" class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <a @click="btnWriteNoti" v-if="isAdmin" class="admin writing"
      >게시물 추가</a
    >
    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">공고</h3>
      </div>
      <div class="txt">
        <div class="Public_list">
          <div class="Public_search w300">
            <input type="text" v-model="searchText" />
            <a @click="reqList"></a>
          </div>
          <ul class="list">
            <li>
              <dl>
                <dt class="number">번호</dt>
                <dt class="tit">제 목</dt>
                <dt class="user">작성자</dt>
                <dt class="day">작성일자</dt>
              </dl>
            </li>

            <li v-for="(obj, index) in docs" :key="index">
              <a @click="btnDetail(obj)">
                <dl>
                  <dd class="number">
                    {{ totalDocs - (pagingCounter + index) + 1 }}
                  </dd>
                  <dd class="tit">{{ obj.title }}</dd>
                  <dd class="user">{{ obj.writer }}</dd>
                  <dd class="day">{{ obj.createdAt | date }}</dd>
                </dl>
              </a>
            </li>
          </ul>
        </div>
        <div class="Public_number">
          <ul>
            <li v-if="hasPrevPage">
              <a class="arrow-l" @click="btnPrevPage"></a>
            </li>

            <li v-for="index in totalPages" :key="index">
              <a :class="{ on: page == index }" @click="btnSelPage(index)">{{
                index
              }}</a>
            </li>
            <li v-if="hasNextPage">
              <a class="arrow-r" @click="btnNexPage"></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <modal name="NotiPopup" width="850px" height="auto" :clickToClose="false">
      <div id="NotiPopup">
        <div class="top">
          <h6>공고 상세</h6>
          <button class="btn_correction" v-if="isAdmin" @click="btnModify">
            수정
          </button>

          <button class="btn_deletion" v-if="isAdmin" @click="btnDeleteDetail">
            삭제
          </button>
          <button @click="btnClose()" class="close">닫기</button>
        </div>
        <div class="contents">
          <div class="News_tit">
            <h4>{{ detailObj.title }}</h4>
            <p class="day">{{ detailObj.createdAt | date }}</p>
          </div>
          <h4>작성자</h4>
          <p>{{ detailObj.writer }}</p>
          <br /><br />

          <div v-html="detailObj.content"></div>

          <!-- 첨부파일 -->
          <div
            v-if="
              detailObj.files &&
                detailObj.files.file &&
                detailObj.files.file.length != 0
            "
          >
            <div
              class="bnt_area"
              v-for="(obj, index) in detailObj.files.file"
              :key="index"
            >
              <button class="btn_download" @click="nasDownload(obj.filename)">
                {{ obj.originalname }}
              </button>
            </div>
          </div>
          <!-- 첨부파일 -->
        </div>
      </div>
    </modal>

    <router-view />
  </div>
</template>

<script>
import pm from "../common/protocolManager";
import eventBus from "../common/eventBus";

export default {
  data: () => ({
    message: "PublicAnnouncement.vue",
    isAdmin: false,
    searchText: "",
    detailObj: {
      id: "",
      title: "",
      content: "",
      createdAt: new Date(),
      writer: "",
      files: {
        file: []
      }
    },
    docs: [],
    hasNextPage: false,
    hasPrevPage: false,
    limit: 5,
    nextPage: 2,
    page: 1,
    pagingCounter: 1,
    prevPage: null,
    totalDocs: 17,
    totalPages: 4
  }),
  methods: {
    btnModify() {
      this.btnClose();
      this.$router.push(`/Invest/NotiList/writeNoti/1`);
    },
    btnNexPage() {
      if (false == this.hasNextPage) {
        return;
      }
      console.log("btnNexPage");
      this.btnSelPage(this.page + 1);
    },
    btnPrevPage() {
      if (false == this.hasPrevPage) {
        return;
      }
      console.log("btnPrevPage");
      this.btnSelPage(this.page - 1);
    },
    btnSelPage(pageNum) {
      console.log("btnSelPage");
      this.page = pageNum;
      this.reqList();
    },
    btnClose() {
      // document.body.style = "";
      this.$modal.hide("NotiPopup");
      let agent = navigator.userAgent.toLowerCase();
      if (
        (navigator.appName == "Netscape" &&
          navigator.userAgent.search("Trident") != -1) ||
        agent.indexOf("msie") != -1
      ) {
        // alert("인터넷 익스플로러 브라우저 입니다.");

        let bodyStyle = document.getElementById("body").style;
        bodyStyle.setAttribute("overflow", "auto");
      } else {
        // alert("인터넷 익스플로러 브라우저가 아닙니다.");
        document.body.style = "";
      }
    },
    btnDetail(obj) {
      console.log("btnDetail");
      // this.$localStorage.remove("notiDetailObj");
      this.$localStorage.set("notiDetailObj", obj);
      this.detailObj = obj;
      // testData1 = obj;
      this.$modal.show("NotiPopup");
      let agent = navigator.userAgent.toLowerCase();
      if (
        (navigator.appName == "Netscape" &&
          navigator.userAgent.search("Trident") != -1) ||
        agent.indexOf("msie") != -1
      ) {
        // alert("인터넷 익스플로러 브라우저 입니다.");

        let bodyStyle = document.getElementById("body").style;
        bodyStyle.setAttribute("overflow", "hidden");
      } else {
        // alert("인터넷 익스플로러 브라우저가 아닙니다.");
        document.body.style = "overflow: hidden;";
      }
    },
    btnDeleteDetail() {
      console.log("btnDeleteDetail");
      if (confirm("정말 삭제하시겠습니까?")) {
        let url = "ferrum/deleteNoti";
        let params = {
          id: this.detailObj.id
        };
        pm.post(url, params)
          .then(result => {
            console.log("btnDelete ok");
            alert("삭제되었습니다.");
            this.btnClose();
            this.reqList();
          })
          .catch(err => {
            console.log("btnDelete err");
            alert("삭제 실패");
          });

        //   pm.post
      }
    },
    btnWriteNoti() {
      console.log("btnNewBoard");
      this.$router.push(`/Invest/NotiList/writeNoti/0`);
    },
    reqList() {
      console.log("reqList");
      let url = `ferrumNotiList?page=${this.page}&limit=10&fields=title&filter=${this.searchText}`;

      pm.get(url)
        .then(result => {
          console.log("reqList - ok");
          if (result.list) {
            this.docs = result.list.docs;
            this.hasNextPage = result.list.hasNextPage;
            this.hasPrevPage = result.list.hasPrevPage;
            this.limit = result.list.limit;
            this.nextPage = result.list.nextPage;
            this.page = result.list.page;
            this.pagingCounter = result.list.pagingCounter;
            this.prevPage = result.list.prevPage;
            this.totalDocs = result.list.totalDocs;
            this.totalPages = result.list.totalPages;

            console.log("limit = " + this.limit);
            console.log("nextPage = " + this.nextPage);
            console.log("page = " + this.page);
            console.log("pagingCounter = " + this.pagingCounter);
            console.log("totalDocs = " + this.totalDocs);
            console.log("totalPages = " + this.totalPages);
          }
        })
        .catch(error => {
          console.log("error");
          alert("reqBoardList 에러");
        });
    },
    checkAdmin() {
      let url = "ferrum/isAdmin";
      pm.get(url)
        .then(result => {
          console.log("checkAdmin - ok");
          if (result.role === 'admin') {
            this.isAdmin = true;
          } else {
            this.isAdmin = false;
          }
        })
        .catch(err => {
          console.log("checkAdmin - err");
          this.isAdmin = false;
        });
    }
  },
  computed: {},
  mounted() {
    // this.$modal.show("NotiPopup");
  },
  destroyed() {
    eventBus.$off("EVENT_CHANGE_NOTI");
  },

  created() {
    console.log("created - " + this.message);
    this.checkAdmin();
    eventBus.$on("EVENT_CHANGE_NOTI", payload => {
      this.page = 0;
      this.searchText = "";
      this.reqList();
    });

    this.reqList();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/sub05/NotiList.vue